// extracted by mini-css-extract-plugin
module.exports = {"wrap":"List_wrap_2Ldd7","main":"List_main_8JD7T","side":"List_side_3V8bS","btn":"List_btn_qHKME","list":"List_list_3URFV"};